import React from 'react';
import { Chip, Tooltip } from '@mui/material';

// Shared with the help panel so the wording stays in one place
export const STATUS = {
    draft: {
        label: 'Draft', color: 'default', variant: 'filled',
        help: 'Being prepared by its contributor. Only they and approvers can see it.'
    },
    in_review: {
        label: 'In review', color: 'warning', variant: 'filled',
        help: 'Submitted and waiting for an approver. Contributors and approvers can see it.'
    },
    published: {
        label: 'Published', color: 'success', variant: 'filled',
        help: 'Approved. Every committee member can find and download it.'
    },
    superseded: {
        label: 'Superseded', color: 'default', variant: 'outlined',
        help: 'Replaced by a newer revision. Still downloadable from the Revisions list.'
    },
    withdrawn: {
        label: 'Withdrawn', color: 'error', variant: 'outlined',
        help: 'Taken out of the library by an approver. Hidden from search; files cannot be downloaded.'
    }
};

const StatusChip = ({ status, size = 'small' }) => {
    const s = STATUS[status] || { label: status, color: 'default', variant: 'outlined' };
    const chip = <Chip size={size} label={s.label} color={s.color} variant={s.variant} />;
    return s.help ? <Tooltip title={s.help}>{chip}</Tooltip> : chip;
};

export default StatusChip;
